<template>
  <div v-tloading="tableLoading">
    <ModuleSection title="收款人名册">
      <div slot="right-cont">
        <el-button
          type="primary"
          class="title-button"
          @click="handleAdd"
        >
          <svg
            class="icon grey-icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-tianjia1"></use>
          </svg>
          {{$t("添加收款人")}}
        </el-button>
      </div>
      <div class="tabs">
        <div
          v-for="(item,index) in tabLists"
          :key="index"
          :class="['tab',{'active':recBankType === item.id}]"
          @click="handleToogleTabs(item)"
        >
          {{ $t(item.label) }}
        </div>
      </div>
      <el-form
        ref="form"
        label-width="180px"
        :model="formData"
        :rules="rules"
        label-position="top"
      >
        <el-row :gutter="40">
          <!-- 汇款人姓名 -->
          <el-col :span="12">
            <el-form-item
              prop="recAccountName"
              :label="$t('户名')"
            >
              <template>
                <el-input
                  class="union-field"
                  v-model="formData.recAccountName"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="searchAccount"
              :label="$t('账户')"
            >
              <template>
                <el-input
                  class="union-field"
                  v-model="formData.searchAccount"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col>
            <el-button
              class="button"
              @click="handleQuery"
            >{{$t('查询')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <DataTable
        class="table"
        :columnList="recBankType == '1' ? columnListOther : columnList"
        :data="list"
      >
        <el-table-column
          :label="$t('操作')"
          :width="operateWidth"
          prop="operate"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-link
              type="primary"
              @click="handleTransfer(row)"
            >
              {{$t('汇款')}}
            </el-link>
            <el-link
              type="primary"
              @click="handleModify(row)"
            >
              {{$t('修改')}}
            </el-link>
            <el-link
              type="primary"
              v-if="recBankType == '1'"
              @click="handleDetails(row)"
            >
              {{$t('查看详情')}}
            </el-link>
            <el-link
              type="danger"
              @click="handleRemove(row)"
            >
              {{$t('删除')}}
            </el-link>
          </template>
        </el-table-column>
      </DataTable>
      <Pagination
        :total="total"
        @current-change="handleCurrentChange"
      />
    </ModuleSection>
  </div>

</template>
<script>
import { showCustomerPayeeList } from '@/views/outward/api/index'
import { deleteCustomerPayee } from '@/views/outward/api/payeeListOutward'
import { mapState } from 'vuex'
import Pagination from '@/components/table/pagination'
export default {
  components: {
    Pagination
  },
  data () {
    return {
      // 激活的tab
      recBankType: '1',

      tabLists: [
        { label: '他行账户', id: '1' },
        { label: '本行账户', id: '0' }
      ],
      columnListOther: [
        { label: '户名', prop: 'recAccountName', width: 300 },
        { label: '账号', prop: 'recAccount', width: 180 },
        { label: 'SWIFT', prop: 'bankSwift', width: 180 },
        { label: '备注', prop: 'rem', width: 200 }
      ],
      columnList: [
        { label: '户名', prop: 'recAccountName' },
        { label: '账号', prop: 'recAccount' },
        { label: '备注', prop: 'rem' }
      ],
      rules: {
        recAccountName: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        searchAccount: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
      formData: {
        // 户名
        recAccountName: '',
        // 账户
        searchAccount: '',
        pageNum: '1',
        pageSize: '10',
        businessCode: '10200500',
        currentBusinessCode: '10200500'
      },
      list: [],
      total: 0,
      tableLoading: false
    }
  },
  computed: {
    ...mapState('app', ['lang']),

    operateWidth () {
      if (this.lang === 'zh-CN') {
        if (~~this.recBankType === 1) {
          return 270
        } else {
          return 200
        }
      } else {
        if (~~this.recBankType === 1) {
          return 360
        } else {
          return 280
        }
      }
    }
  },
  methods: {
    // 查询列表接口
    queryTableList () {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.tableLoading = true
      showCustomerPayeeList({
        recBankType: this.recBankType,
        ...this.formData
      }).then(res => {
        if (res) {
          this.list = res.list.map(item => item)
          this.total = res.totalSize
        }
      }).catch(_ => {
        console.error(_)
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 切换tab
    handleToogleTabs (item) {
      this.recBankType = item.id
      this.list = []
      this.handleQuery()
    },
    // 查询
    handleQuery () {
      this.formData.pageNum = '1'
      this.queryTableList()
    },
    // 添加收款人
    handleAdd () {
      this.$router.push({
        name: 'PayeeListOutwardAdd',
        query: {
          recBankType: this.recBankType
        }
      })
    },
    // 汇款
    handleTransfer (row) {
      // 5位二进制：录入、复核、发送、管理、强制授权。如：10000表示只有录入权限
      // const userRight = sessionInfo.session_userRight
      const userRight = this.$store.state.home.sessionInfo.session_userRight
      const manageFlag = userRight.substring(0, 1)
      if (manageFlag === '1') {
        // 跨行转账
        if (this.recBankType === '1') {
          const data = {
            recAccount: row.recAccount,
            recAccountName: row.recAccountName,
            bankSwift: row.bankSwift,
            agencyBankAddress: row.agencyBankAddress
            // currentBusinessCode: '10200300'
            // windowId: currentMVC.windowId
          }
          this.$router.push({
            name: 'InterBankOutward',
            query: data
          })
        } else {
          // 本行转账
          const data = {
            recAccount: row.recAccount,
            recAccountName: row.recAccountName
            // currentBusinessCode: '10200000'
          }
          this.$router.push({
            name: 'InnerBankOutward',
            query: data
          })
        }
      } else {
        this.$talert('您当前角色不是提交人，无权限使用付款转账功能')
      }
    },
    // 修改
    handleModify (row) {
      this.$router.push({
        name: 'PayeeListOutwardModify',
        query: {
          searchAccount: row.recAccount,
          recBankType: this.recBankType
        }
      })
    },
    // 删除
    handleRemove (row) {
      const data = {
        recAccount: row.recAccount,
        recBankType: this.recBankType,
        currentBusinessCode: this.formData.currentBusinessCode
      }
      this.$tconfirm('您确认要删除此条收款人吗？', '提示').then(() => {
        deleteCustomerPayee(data).then(res => {
          if (res) {
            this.$success('删除成功')
            this.queryTableList()
          }
        })
      }).catch((_) => {
        console.error(_)
      })
    },
    // 查看详情
    handleDetails (row) {
      this.$router.push({
        name: 'PayeeListOutwardDetails',
        query: {
          searchAccount: row.recAccount
        }
      })
    },
    // 分页
    handleCurrentChange (val) {
      this.formData.pageNum = val
      this.queryTableList()
    }
  },
  created () {
    // 路由控制进入本行还是他行
    this.recBankType = this.$route.query.recBankType || '1'
    this.queryTableList()
  }
}
</script>
<style lang="less" scoped>
.title-button {
  width: 164px;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ span {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 25px;
  }
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}
.tabs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 40px;
  overflow: hidden;
  cursor: pointer;

  .tab {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 104px;
    padding: 0 10px;
    height: 54px;
    color: #a1a7c4;
    background-color: #f6f7fc;
    border: 1px solid #f6f7fc;
    border-radius: 5px;
    &:hover {
      color: @blue;
    }
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-child {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &.active {
      color: @blue;
      background-color: @white;
      border-color: #e6e9f4;
      box-shadow: 0px 4px 10px 0px rgba(51, 55, 82, 0.06);
    }
  }
}
.button-group {
  // display: flex;
  // justify-content: space-between;
  // flex-wrap: wrap;
}
.button {
  min-width: 140px;
  margin-top: 18px;
}
.table {
  margin-top: 40px;
}
.el-link + .el-link {
  margin-left: 30px;
}
</style>
